/**
 * Administration controller
 */

import collapse from '@alpinejs/collapse';
import Alpine from 'alpinejs';

export default class {
  boot() {
    if (!document.querySelector('#AbbottDLAdminView')) {
      return;
    }

    // init Alpine
    Alpine.plugin(collapse);
    window.Alpine = Alpine;
    Alpine.start();
  }
}
